import { render, staticRenderFns } from "./MusicMedia.vue?vue&type=template&id=4b447bc6&scoped=true"
import script from "./MusicMedia.vue?vue&type=script&lang=js"
export * from "./MusicMedia.vue?vue&type=script&lang=js"
import style0 from "./MusicMedia.vue?vue&type=style&index=0&id=4b447bc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b447bc6",
  null
  
)

export default component.exports